<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Borrower Solicitor Details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class=col-sm-6>
        <fmc-crumb-search
          [parentFormGroup]="formGroup"
          [controlName]="'solicitorBorrower'"
          [placeholderText]="'Borrower Solicitor'"
          [partyRoleType]="'solicitor'"
        ></fmc-crumb-search>
      </div>
    </div>
  </mat-card-content>
</mat-card>
